import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ClientTestimonials = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      client: "Sarah Al-Mansouri",
      position: "Chief Financial Officer",
      company: "Gulf Investment Holdings",
      industry: "Private Equity",
      content: `Northbridge Valuation & Advisory provided exceptional expertise during our portfolio company exit. Their defensible valuation methodology and clear communication helped us achieve optimal transaction outcomes. The team's understanding of GCC market dynamics was invaluable.`,
      outcome: "Successful $45M portfolio exit",
      relationship: "3 years",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
      rating: 5
    },
    {
      id: 2,
      client: "Ahmed Al-Rashid",
      position: "Managing Partner",
      company: "Al-Rashid Legal Consultancy",
      industry: "Legal Services",
      content: `As litigation counsel, I've worked with many valuation experts. Northbridge Valuation & Advisory stands out for their meticulous approach and ability to withstand cross-examination. Their court testimony was instrumental in securing favorable outcomes for our clients.`,
      outcome: "Won 8 out of 10 litigation cases",
      relationship: "4 years",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
      rating: 5
    },
    {
      id: 3,
      client: "Fatima Al-Zahra",
      position: "Founder & CEO",
      company: "TechVenture MENA",
      industry: "Technology",
      content: `The team helped us navigate complex valuation challenges during our Series B funding round. Their startup-focused approach and understanding of technology valuations gave investors confidence in our numbers. Highly professional and responsive throughout.`,
      outcome: "Raised $12M Series B funding",
      relationship: "2 years",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      rating: 5
    },
    {
      id: 4,
      client: "Mohammed Al-Thani",
      position: "Investment Director",
      company: "Qatar Family Office",
      industry: "Family Office",
      content: `Northbridge Valuation & Advisory has been our trusted advisor for family business succession planning. Their sensitivity to family dynamics combined with technical excellence has helped us structure optimal ownership transitions while maintaining business continuity.`,
      outcome: "Smooth succession for 3 family businesses",
      relationship: "5 years",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
      rating: 5
    }
  ];

  const clientLogos = [
    { name: "Gulf Investment Holdings", logo: "https://via.placeholder.com/120x60/0EA5E9/FFFFFF?text=GIH" },
    { name: "Al-Rashid Legal", logo: "https://via.placeholder.com/120x60/0EA5E9/FFFFFF?text=ARL" },
    { name: "TechVenture MENA", logo: "https://via.placeholder.com/120x60/0EA5E9/FFFFFF?text=TVM" },
    { name: "Qatar Family Office", logo: "https://via.placeholder.com/120x60/0EA5E9/FFFFFF?text=QFO" },
    { name: "Emirates Capital", logo: "https://via.placeholder.com/120x60/0EA5E9/FFFFFF?text=EC" },
    { name: "Bahrain Development Bank", logo: "https://via.placeholder.com/120x60/0EA5E9/FFFFFF?text=BDB" }
  ];

  const nextTestimonial = () => {
    setActiveTestimonial((prev) => (prev + 1) % testimonials?.length);
  };

  const prevTestimonial = () => {
    setActiveTestimonial((prev) => (prev - 1 + testimonials?.length) % testimonials?.length);
  };

  return (
    <>
    {/* <div className="bg-muted/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-semibold text-text-primary mb-4">
            Client Testimonials & Success Stories
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Our clients' success is our success. Here's what they say about working with Northbridge Valuation & Advisory and the outcomes we've achieved together.
          </p>
        </div>

        <div className="bg-card rounded-xl shadow-brand border border-border p-8 mb-12">
          <div className="grid lg:grid-cols-3 gap-8 items-center">
            <div className="lg:col-span-2">
              <div className="flex items-center mb-6">
                {[...Array(testimonials?.[activeTestimonial]?.rating)]?.map((_, i) => (
                  <Icon key={i} name="Star" size={20} className="text-warning fill-current" />
                ))}
              </div>
              
              <blockquote className="text-lg text-text-primary leading-relaxed mb-6">
                "{testimonials?.[activeTestimonial]?.content}"
              </blockquote>
              
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden">
                    <Image
                      src={testimonials?.[activeTestimonial]?.avatar}
                      alt={testimonials?.[activeTestimonial]?.client}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <div className="font-semibold text-text-primary">
                      {testimonials?.[activeTestimonial]?.client}
                    </div>
                    <div className="text-sm text-text-secondary">
                      {testimonials?.[activeTestimonial]?.position}
                    </div>
                    <div className="text-sm text-accent">
                      {testimonials?.[activeTestimonial]?.company}
                    </div>
                  </div>
                </div>
                
                <div className="text-right">
                  <div className="text-sm font-medium text-success mb-1">
                    {testimonials?.[activeTestimonial]?.outcome}
                  </div>
                  <div className="text-xs text-text-secondary">
                    {testimonials?.[activeTestimonial]?.relationship} partnership
                  </div>
                </div>
              </div>
            </div>
            
            <div className="lg:col-span-1">
              <div className="bg-muted/50 rounded-lg p-6 text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-accent/10 rounded-full mb-4">
                  <Icon name="Award" size={32} className="text-accent" />
                </div>
                <div className="text-sm text-text-secondary mb-2">Industry</div>
                <div className="font-semibold text-text-primary">
                  {testimonials?.[activeTestimonial]?.industry}
                </div>
              </div>
            </div>
          </div>
          
          <div className="flex items-center justify-between mt-8 pt-6 border-t border-border">
            <button
              onClick={prevTestimonial}
              className="flex items-center space-x-2 px-4 py-2 rounded-lg hover:bg-muted transition-colors duration-200"
            >
              <Icon name="ChevronLeft" size={20} className="text-accent" />
              <span className="text-sm font-medium text-text-primary">Previous</span>
            </button>
            
            <div className="flex space-x-2">
              {testimonials?.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveTestimonial(index)}
                  className={`w-3 h-3 rounded-full transition-colors duration-200 ${
                    index === activeTestimonial ? 'bg-accent' : 'bg-border hover:bg-accent/50'
                  }`}
                />
              ))}
            </div>
            
            <button
              onClick={nextTestimonial}
              className="flex items-center space-x-2 px-4 py-2 rounded-lg hover:bg-muted transition-colors duration-200"
            >
              <span className="text-sm font-medium text-text-primary">Next</span>
              <Icon name="ChevronRight" size={20} className="text-accent" />
            </button>
          </div>
        </div>

       
      </div>
    </div> */}
    </>
  );
};

export default ClientTestimonials;